module.exports = __webpack_public_path__ + "img/tOFI-compressor.7efa2d46.jpg";